const drawings = {
    flower: (
        <>
            <path d="M90 29C73 20 76 7 85 10C92 12 94 21 92 27C97 12 109 13 110 22C111 29 102 34 94 31C109 33 112 43 104 47C97 50 91 42 90 34C89 47 78 50 74 43C70 35 79 30 86 30C73 29 69 21 74 17" />
            <path d="M91 29c5 0 6 7 1 8-5 2-8-5-4-8M91 38c-6 15 8 24 1 34M93 57c8-9 17-8 20-5-5 6-13 7-20 5M91 63c-7-10-18-11-22-7 5 7 15 10 22 7" />
            <path d="m52 22 2-5 2 5 5 2-5 2-2 5-2-5-5-2ZM128 39l2-4 2 4 4 2-4 2-2 4-2-4-4-2Z" />
        </>
    ),
    thread: (
        <>
            <path d="M5 50c17 0 18-23 36-23 14 0 21 21 10 29-10 8-17-5-6-11 17-10 24 14 42 9 19-5 18-36 42-28 10 3 14 10 15 17" />
            <path d="M145 39c-11-11-4-18 2-15 5 3 6 10 1 15 9-8 17-3 13 4-3 5-10 4-15 1 8 8 2 16-4 11-4-4-3-9 1-12-11 4-15-4-9-7 4-3 8 1 11 3Z" />
            <path d="M147 44c-5 12 8 13 15 10 6-3 7-7 13-6" />
        </>
    ),
    spark: (
        <>
            <path d="M80 17c2 14 5 18 18 21-13 3-16 7-18 21-3-14-6-18-19-21 13-3 16-7 19-21ZM118 39c1 7 3 10 10 11-7 2-9 4-10 11-2-7-4-9-11-11 7-1 9-4 11-11Z" />
            <path d="m43 23 4 4m-8 8 6-1m71-15-2 5m21 6-5 1" />
        </>
    ),
}

const MakerDoodle = ({ variant = 'flower', className = '' }) => (
    <svg
        className={`maker-doodle ${className}`.trim()}
        viewBox="0 0 180 80"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
    >
        {drawings[variant] || drawings.flower}
    </svg>
)

export default MakerDoodle
